module.exports = __webpack_public_path__ + "img/debit.a6887aaf.png";